import React from 'react';
import DialogContent from "@material-ui/core/DialogContent";
import AppButton from "../../ui/AppButton";
import Dialog from "@material-ui/core/Dialog";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import Grid from "@material-ui/core/Grid";
import AppInputText from "../../ui/AppInputText";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import AppTextArea from "../../ui/AppTextArea";
import Api from "../../helpers/Api";
import Env from "../../config/env";
import AppToast from "../../ui/AppToast";
import ValidateForm from "../../helpers/ValidateForm";
import GetDataApi from "../../helpers/GetDataApi";
import Session from "../../helpers/Session";
import Alert from "@material-ui/lab/Alert";
import ValidateSizeFile from "../../helpers/ValidateSizeFile";
import Button from "@material-ui/core/Button";
import PrintIcon from '@material-ui/icons/Print';
import {getFileExtension} from "../../helpers/Helpers";

const initialForm = {
    account: {
        key: 'account',
        value: '',
        required: true
    },
    observation: {
        key: 'observation',
        value: '',
        required: true
    },
    typeClain: {
        key: 'typeClain',
        value: 'WE',
        required: true
    },
    typeProcessing: {
        key: 'typeProcessing',
        value: '',
        required: true
    },
    department: {
        key: 'department',
        value: '',
        required: true
    },
    city: {
        key: 'city',
        value: '',
        required: true
    },
    address: {
        key: 'address',
        value: '',
        required: true
    },
};

class CreateNewPqr extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            loadData: {
                tipoTramite: []
            },
            departamentos: [],
            municipios: [],
            departamentoSelected: null,
            municipioSelected: null,
            openDialogRes: false,
            response: '',
            form: initialForm,
            files: []
        };
    }

    componentDidMount() {
        this.setAccountCode();
        this.getTypeProcessing();
        this.getDepartmens();
    }

    initForm() {
        this.setState({
            form: initialForm,
            files: [],
            departamentoSelected: null,
            municipioSelected: null,
        });
        this.setAccountCode();
    }

    setAccountCode = () => {
        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    account: {
                        ...statePrev.form.account,
                        value: this.props.getCodeAccount()
                    }
                }
            }
        });
    }

    getTypeProcessing = async () => {
        let params = {
            typeClain: Env.TypeClain
        }
        const data = await Api.post(`${Env.UrlBackend}/get-type-processing`, params);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({
            loadData: {
                tipoTramite: data.data
            }
        });
    }

    getDepartmens = async () => {
        const data = await Api.get(`${Env.UrlBackend}/get-departamentos`);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({departamentos: data.data});
    }

    getCities = async (departamentoID) => {
        const data = await Api.get(`${Env.UrlBackend}/get-municipios/${departamentoID}`);
        if (!data.success) {
            AppToast(data.message, false);
        }
        this.setState({municipios: data.data});
    }

    handleChangeFiles = (e) => {
        const selectorFiles = e.target.files;

        // Valida que escoja maximo la cantidad parametrizada de archivos
        if (!this.validateCountFiles(selectorFiles)) {
            e.target.value = '';
            return;
        }

        // Valido que el tamaño de los archivos no superen el valor parametrizado
        if (this.validateSizeFiles(selectorFiles)) {
            this.setState({
                files: selectorFiles
            });
        } else {
            AppToast(`El tamaño permitido para cada archivo es de ${Env.AllowedSize} mega`, false);
            this.setState({
                files: []
            });
            e.target.value = '';
        }

        // Valido que se adjunten solo las extensiones permitidas
        if (this.validateExtensionFiles(selectorFiles)) {
            this.setState({
                files: selectorFiles
            });
        } else {
            AppToast(`Sólo se pueden adjuntar archivos: ${Env.AllowedExtensionFiles.toString()}.`, false);
            this.setState({
                files: []
            });
            e.target.value = '';
        }
    }

    validateCountFiles = (selectorFiles) => {
        if (selectorFiles.length > Env.AllowedNumberFiles) {
            AppToast(`Puede adjuntar hasta ${Env.AllowedNumberFiles} archivos`, false);
            return false;
        }
        return true;
    }

    validateSizeFiles = (selectorFiles) => {
        let valid = true;
        for (let i = 0; i < selectorFiles.length; i++) {
            const file = selectorFiles[i];
            if (!ValidateSizeFile(file)) {
                valid = false;
                break;
            }
        }
        return valid;
    }

    validateExtensionFiles = (selectorFiles) => {
        let valid = true;
        for (let i = 0; i < selectorFiles.length; i++) {
            const file = selectorFiles[i];
            const fileExtension = getFileExtension(file.name);
            if (!Env.AllowedExtensionFiles.includes(fileExtension)) {
                valid = false;
                break;
            }
        }
        return valid;
    }

    handleChange = async (e) => {
        const valueText = e.nativeEvent.target.innerText;
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }
        });

        switch (name) {
            case this.state.form.department.key:
                this.setState({departamentoSelected: valueText});
                await this.getCities(value);
                break;
            case this.state.form.city.key:
                this.setState({municipioSelected: valueText});
                break;
            default:
                break;
        }

    }

    handleSubmit = async () => {

        // Valida los campos obligatorios
        if (!ValidateForm(this.state.form)) {
            return;
        }

        let params = GetDataApi(this.state.form);

        const userData = Session.getLogin();
        const dataPerson = {
            name: `${userData.terceroNombre1} ${userData.terceroNombre2} ${userData.terceroApellido1} ${userData.terceroApellido2}`,
            email: userData.terceroMail,
            telephone: userData.terceroTel,
            cellphone: userData.terceroCel,
            address: userData.terceroDireccion,
            documentNumber: userData.terceroDocumento,
        };
        params = {
            ...params,
            dataPerson: JSON.stringify(dataPerson),
            departamentoSelected: this.state.departamentoSelected,
            municipioSelected: this.state.municipioSelected,
        }

        const formData = this.getFormData(params);
        const data = await Api.postWithoutFormData(`${Env.UrlBackend}/save-pqr`, formData);
        if (!data.success) {
            AppToast(data.message, false);
        } else {
            this.setState({
                openDialogRes: true,
                response: data.message,
            });
            this.resetForm();
        }

    }

    getFormData = (params) => {
        let formData = new FormData();
        for (let i = 0; i < this.state.files.length; i++) {
            formData.append("file[]", this.state.files[i]);
        }
        for (const name in params) {
            formData.append(name, params[name]);
        }
        return formData;
    }

    resetForm = () => {
        this.props.onClose(false);
        this.props.getPqrs();
        this.initForm();
    }

    handleCloseDialogRes = () => {
        this.setState({
            openDialogRes: false
        })
    }

    handlePrint = () => {
        window.print();
    }

    render() {

        const {open, codeAccount, onClose} = this.props;

        return (
            <div>

                <Dialog onClose={this.handleCloseDialogRes} aria-labelledby="customized-dialog-title"
                        open={this.state.openDialogRes}>
                    <DialogContent style={{padding: '0px'}}>
                        <AppBar style={{position: 'relative'}}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={this.handleCloseDialogRes}
                                            aria-label="close">
                                    <CloseIcon/>
                                </IconButton>
                                <Typography variant="h6">
                                    <b>PQR Creada con éxito</b>
                                </Typography>
                            </Toolbar>
                        </AppBar>
                        <div style={{padding: '30px'}}>
                            <div dangerouslySetInnerHTML={{__html: this.state.response}}/>

                            <div style={{textAlign: 'center'}}>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    onClick={this.handlePrint}
                                    startIcon={<PrintIcon/>}
                                >
                                    Imprimir
                                </Button>
                            </div>

                        </div>
                    </DialogContent>
                </Dialog>

                <Dialog onClose={onClose} aria-labelledby="customized-dialog-title"
                        open={open}>
                    <DialogContent style={{padding: '0px'}}>
                        <AppBar style={{position: 'relative'}}>
                            <Toolbar>
                                <IconButton edge="start" color="inherit" onClick={onClose}
                                            aria-label="close">
                                    <CloseIcon/>
                                </IconButton>
                                <Typography variant="h6">
                                    <b>Crear Nueva PQR</b>
                                </Typography>
                            </Toolbar>
                        </AppBar>

                        <div style={{padding: '30px'}}>
                            <Grid container spacing={1}>
                                <Grid item xs={12}>
                                    <AppInputText
                                        id={this.state.form.account.key}
                                        name={this.state.form.account.key}
                                        value={codeAccount}
                                        label='Cuenta'
                                        disabled={true}
                                        onChange={this.handleChange}
                                        required={this.state.form.account.required}
                                    />
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl required variant="outlined" style={{width: '100%'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Departamento</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id={this.state.form.department.key}
                                            name={this.state.form.department.key}
                                            value={this.state.form.department.value}
                                            onChange={this.handleChange}
                                            label="Departamento"
                                            required={true}
                                            variant='outlined'
                                        >
                                            {this.state.departamentos.map((val, index) => {
                                                return (
                                                    <MenuItem key={index}
                                                              value={val.codigo}>{val.nombre}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={6}>
                                    <FormControl required variant="outlined" style={{width: '100%'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Municipio</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id={this.state.form.city.key}
                                            name={this.state.form.city.key}
                                            value={this.state.form.city.value}
                                            onChange={this.handleChange}
                                            label="Municipio"
                                            required={true}
                                            variant='outlined'
                                        >
                                            {this.state.municipios.map((val, index) => {
                                                return (
                                                    <MenuItem key={index}
                                                              value={val.codigo}>{val.nombre}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                    <AppInputText
                                        id={this.state.form.address.key}
                                        name={this.state.form.address.key}
                                        value={this.state.form.address.value}
                                        label='Dirección notificación física'
                                        onChange={this.handleChange}
                                        required={this.state.form.address.required}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <FormControl required variant="outlined" style={{width: '100%'}}>
                                        <InputLabel id="demo-simple-select-outlined-label">Tipo de trámite</InputLabel>
                                        <Select
                                            labelId="demo-simple-select-outlined-label"
                                            id={this.state.form.typeProcessing.key}
                                            name={this.state.form.typeProcessing.key}
                                            value={this.state.form.typeProcessing.value}
                                            onChange={this.handleChange}
                                            label="Tipo trámite"
                                            required={true}
                                            variant='outlined'
                                        >
                                            {this.state.loadData.tipoTramite.map((val, index) => {
                                                return (
                                                    <MenuItem key={index}
                                                              value={val.codigo}>{val.descripcion}</MenuItem>
                                                );
                                            })}
                                        </Select>
                                    </FormControl>
                                </Grid>

                                <Grid item xs={12}>
                                    <AppTextArea
                                        id={this.state.form.observation.key}
                                        name={this.state.form.observation.key}
                                        value={this.state.form.observation.value}
                                        label="Observación"
                                        onChange={this.handleChange}
                                        required={this.state.form.observation.required}
                                        helperText={`${this.state.form.observation.value.length}/400`}
                                    />
                                </Grid>

                                <Grid item xs={12}>
                                    <input type="file"
                                           style={{padding: '10px'}}
                                           multiple
                                           onChange={(e) => this.handleChangeFiles(e)}/>
                                    <Alert severity="info">
                                        * Puede ingresar varios archivos presionando la tecla
                                        ctrl.
                                        <br/>
                                        * El tamaño máximo para cada archivo es de {Env.AllowedSize} mega.
                                        <br/>
                                        * Puede adjuntar hasta {Env.AllowedNumberFiles} archivos.
                                        <br/>
                                        * Archivos permitidos: {Env.AllowedExtensionFiles.toString()}.

                                    </Alert>
                                </Grid>

                                <Grid item xs={12} style={{textAlign: 'center'}}>
                                    <AppButton
                                        type='button'
                                        label='Guardar'
                                        size='small'
                                        onClick={this.handleSubmit}
                                    />
                                </Grid>

                            </Grid>
                        </div>
                    </DialogContent>
                </Dialog>

            </div>

        );
    }
}

export default CreateNewPqr